function fiduciaryAssessment(asset) {
    let assessment = -1;
    switch (true) {
        case asset > 100000000000:
            assessment = Math.round((asset - 100000000000) * 0.00000023595 + 65041);
            break;
        case asset > 10000000000:
            assessment = Math.round((asset - 10000000000) * 0.00000037344 + 31431);
            break;
        case asset > 1000000000:
            assessment = Math.round((asset - 1000000000) * 0.0000022418 + 11255);
            break;
        default:
            assessment = 11255;
    }
    return assessment;
}

function assetAssessment(asset, bankType) {
    let assessment = -1;
    switch (true) {
        case asset > 20000000000:
            assessment = Math.round(
                (asset - 20000000000) * 0.000022143 + 507021
            );
            break;
        case asset > 6000000000 && asset <= 20000000000:
            assessment = Math.round(
                (asset - 6000000000) * 0.0000235158 + 177800
            );
            break;
        case asset > 2000000000 && asset <= 6000000000:
            multiplier = (bankType == 'TC') ? 0.00002763695 : 0.00002763965;
            assessment = Math.round(
                (asset - 2000000000) * multiplier + 67252
            );
            break;
        case asset > 1000000000 && asset <= 2000000000:
            assessment = Math.round(
                (asset - 1000000000) * 0.00003109205 + 36160
            );
            break;
        case asset > 200000000 && asset <= 1000000000:
            assessment = Math.round((asset - 200000000) * 0.0000323015 + 10319);
            break;
        case asset > 100000000 && asset <= 2000000000:
            assessment = Math.round((asset - 100000000) * 0.00003368 + 6951);
            break;
        case asset > 20000000 && asset <= 1000000000:
            assessment = Math.round((asset - 20000000) * 0.000051818 + 2806);
            break;
        case asset > 2000000 && asset <= 20000000:
            assessment = Math.round((asset - 2000000) * 0.00006478 + 1640);
            break;
        case asset > 0 && asset <= 2000000:
            assessment = 1640;
            break;
        default:
            assessment = 0;
    }
    return assessment;
}

module.exports = { assetAssessment, fiduciaryAssessment };